/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactAddressResponse } from '../../models/contact-address-response';

export interface GetContactAddresses$Params {
  id: number;
}

export function getContactAddresses(http: HttpClient, rootUrl: string, params: GetContactAddresses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactAddressResponse>>> {
  const rb = new RequestBuilder(rootUrl, getContactAddresses.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactAddressResponse>>;
    })
  );
}

getContactAddresses.PATH = '/contacts/{id}/addresses';
